class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.handleTrigger = this.handleTrigger.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.triggers = this.querySelectorAll('[data-klaviyo-id]');
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.handleTrigger);
      trigger.addEventListener('keydown', this.handleKeydown);
    });
  }

  disconnectedCallback() {
    if (this.triggers) {
      this.triggers.forEach((trigger) => {
        trigger.removeEventListener('click', this.handleTrigger);
        trigger.removeEventListener('keydown', this.handleKeydown);
      });
    }
  }

  handleTrigger(e) {
    const trigger = e.currentTarget;
    const formId = trigger.getAttribute('data-klaviyo-id');
    if (!formId) return;

    e.preventDefault();
    e.stopPropagation();

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  handleKeydown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      this.handleTrigger(e);
    }
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar);
}